import { put, call, select } from "redux-saga/effects";

import { getGeoIpData, saveSettingsRequest } from "../../api/not-sorted";
import { _sharedActionsSettings } from "./actions";
import { consoleLogError } from "../../utils/console";
import { selectorSystemIsLogin } from "../system/selectors";
import { storeSetting } from "../../utils/settings/settings";

const scope = "Saga Settings";

export function* _sharedWorkerUpdateSettingsMethod(action) {
  try {
    const { data, saveOnServer = true } = action;
    const isLogin = yield select(selectorSystemIsLogin);
    const settingsList = {};
    const serverSettingsList = {};

    for (const key in data) {
      const value = data[key];
      const setting = storeSetting(key, value);
      if (setting) {
        if (!settingsList[key]) {
          settingsList[key] = value;
        }
        if (isLogin && setting.server) {
          serverSettingsList[key] = value;
        }
      }
    }

    if (saveOnServer && isLogin && Object.keys(serverSettingsList).length) {
      yield call(saveSettingsRequest, serverSettingsList);
    }

    yield put(_sharedActionsSettings.updateSettingSuccess({ ...settingsList }));
  } catch (error) {
    consoleLogError(scope, "Error store settings: ", error);
  }
}

export function* _sharedWorkerFetchGeoIpData() {
  try {
    const { geoIpData } = yield select((state) => state.settings);
    if (Object.keys(geoIpData).length === 0) {
      const data = yield call(getGeoIpData);
      if (data) {
        yield put(_sharedActionsSettings.fetchGeoIpDataSuccess(data));
      }
    }
  } catch (error) {
    consoleLogError(scope, "Error getting GEO data: ", error);
  }
}
